import { useMutation } from "@shared/lib/hooks";
import { BriefConfigService } from "../../services/briefConfigService";
import { ToastService } from "@shared/lib/services";

import { IFieldConfig } from "@shared/lib/types/briefInfluencerV2";

import { BRIEF_CAMPAIGNS_LIST_QUERY_KEY } from "@entities/campaigns/lib/contsants";

interface IToggleBriefDataFieldV2Request {
  briefId: string;
  brandId: string;
  visibileOperationsCustomFieldsV2: IFieldConfig[];
}

export function useToggleBriefCampaignDataFieldV2(briefId: string) {
  const {
    mutate: toggleDataField,
    isLoading: isToggling,
    isSuccess: isToggled,
  } = useMutation({
    mutationFn: (data: IToggleBriefDataFieldV2Request) =>
      BriefConfigService.toggleBriefCampaignDataFieldV2(
        data.briefId,
        data.brandId,
        data.visibileOperationsCustomFieldsV2
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      setTimeout(() => {
        c.invalidateQueries({
          queryKey: [...BRIEF_CAMPAIGNS_LIST_QUERY_KEY(briefId)],
        });
      }, 3000);
    },
  });

  return {
    toggleDataField,
    isToggling,
    isToggled,
  };
}
